const FORM_SUBMIT_ADDR = 'https://readdy.ai/api/form/d9lidksit35ii3jdl8pg';

export async function getFormUrl(): Promise<string> {
  return FORM_SUBMIT_ADDR;
}